export const BuildHash = 'd12e343b';